import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { useIsSuperAdmin } from './hooks/useIsSuperAdmin';
import { Text } from 'foundations-components/components/Text';
import { getFullUrl } from 'hubspot-url-utils';
import { BreezeTertiaryAIBaseButton } from 'ai-components-ui-library/components/buttons/internal/styledButtons/StyledAIBaseButton';
import AILink from 'ai-components-ui-library/components/buttons/AILink';
import PortalIdParser from 'PortalIdParser';
import { useShouldShowCopilotPreviews } from '../../../hooks/useShouldShowCopilotPreviews';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DisabledPreviewControls = ({
  usageTracker,
  onDontShowAgain,
  isDisabledDescriptionOverriden
}) => {
  const isSuperAdmin = useIsSuperAdmin();
  const aiSettingsLink = `${getFullUrl('app')}/ai-settings/${PortalIdParser.get()}`;
  const {
    setDontShowAgain
  } = useShouldShowCopilotPreviews({
    overrideDisabled: true
  });
  const handleDontShowAgain = () => {
    setDontShowAgain();
    usageTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'dont_show_again'
    });
    onDontShowAgain();
  };
  const handleSettingsLinkClick = () => {
    usageTracker.track('Ai Addon Copilot Preview', 'Copilot Preview Interaction', {
      action: 'settings_link_click'
    });
  };
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    alignItems: "start",
    children: [isSuperAdmin && !isDisabledDescriptionOverriden && /*#__PURE__*/_jsx(Text, {
      as: "small",
      children: /*#__PURE__*/_jsx(AILink, {
        href: aiSettingsLink,
        onClick: handleSettingsLinkClick,
        external: true,
        children: unescapedText('aiAddonCopilotPreview.components.disabledPreview.settingsLink')
      })
    }), /*#__PURE__*/_jsx(BreezeTertiaryAIBaseButton, {
      size: "xs",
      onClick: handleDontShowAgain,
      responsive: false,
      children: unescapedText('aiAddonCopilotPreview.components.disabledPreview.dontShowAgainButton')
    })]
  });
};